"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderLanguageSection = renderLanguageSection;
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
var _solidUi = require("solid-ui");
require("./LanguageSection.css");
var _LanguageEditDialog = require("./LanguageEditDialog");
var _profileIcons = require("../../icons-svg/profileIcons");
var _texts = require("../../texts");
var _collapsibleSection = require("../shared/collapsibleSection");
function renderLan(language, asList = false) {
  if (!language) return (0, _litHtml.html)``;
  return asList ? (0, _litHtml.html)`<li class="languages__item-label" role="listitem">${language.name}</li>` : (0, _litHtml.html)``;
}
function renderLanguages(languages, asList = false) {
  if (!languages || !languages.length || !languages[0]) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`${renderLan(languages[0], asList)}${languages.length > 1 ? renderLanguages(languages.slice(1), asList) : (0, _litHtml.html)``}`;
}
function renderLanguagesSectionDefault(store, subject, languages, viewerMode, onSaved) {
  const hasLanguages = Array.isArray(languages) && languages.length > 0;
  const hasLanguageLinks = store.each(subject, _solidUi.ns.schema('knowsLanguage')).length > 0;
  const isOwner = viewerMode === 'owner';
  return (0, _litHtml.html)`
    <section
      class="profile__section profile-section-collapsible profile-section-collapsible--inline-mobile-actions"
      data-profile-section="languages"
      aria-labelledby="languages-heading"
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h3 id="languages-heading">${_texts.languagesHeadingText}</h3>
        <div class="profile-section-collapsible__actions">
          ${isOwner ? (0, _litHtml.html)`
            <solid-ui-button
              type="button"
              variant="secondary"
              size="sm"
              class="profile__action-button profile-action-text profile-section-collapsible__edit-button"
              aria-label="Add or edit languages"
              @click=${event => (0, _LanguageEditDialog.createLanguageEditDialog)(event, store, subject, languages, viewerMode, onSaved)}
            >
              <span class="profile-section-collapsible__edit-label profile__add-more-content">
                <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
                <span>Add More</span>
              </span>
              <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
            </solid-ui-button>
          ` : (0, _litHtml.html)``}
          <solid-ui-button
            type="button"
            variant="icon"
            size="sm"
            class="profile-section-collapsible__toggle-button"
            aria-label="Toggle languages section"
            aria-controls="languages-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
          </solid-ui-button>
        </div>
      </header>
      <div id="languages-panel" class="profile-section-collapsible__content">
        ${hasLanguages ? (0, _litHtml.html)`
              <ul class="languages__list" role="list" aria-label="Known languages">
                ${renderLanguages(languages, true)}
              </ul>
            ` : hasLanguageLinks ? (0, _litHtml.html)`<p>Language details are missing for one or more entries.</p>` : (0, _litHtml.html)`<p>No languages added yet.</p>`}
      </div>
    </section>
  `;
}
function renderOwnerEmptyLanguagesContent(_store, _subject, _languages, _viewerMode, _onSaved) {
  return (0, _litHtml.html)`
      <div class="profile__empty-state-content" role="group" aria-label="Empty languages section">    
        <div class="languages__empty-icon-wrapper">
          <span class="languages__empty-icon">${_profileIcons.commentIcon}</span>
        </div>
        <p class="profile__empty-state-message languages__empty-message">
            No languages added yet.
        </p>
      </div>
  `;
}
function renderOwnerEmptyLanguagesSection(store, subject, languages, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="languages-heading" 
      data-profile-section="languages"
      class="profile__section--empty profile__section--empty-sidebar profile-section-collapsible profile-section-collapsible--inline-mobile-actions" 
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h3 id="languages-heading" tabindex="-1">${_texts.languagesHeadingText}</h3>
        <div class="profile-section-collapsible__actions">
          <solid-ui-button
            type="button"
            variant="secondary"
            size="sm"
            class="profile__action-button profile-action-text profile-section-collapsible__edit-button"
            aria-label="Add languages"
            @click=${event => {
    return (0, _LanguageEditDialog.createLanguageEditDialog)(event, store, subject, languages, viewerMode, onSaved);
  }}
          >
            <span class="profile-section-collapsible__edit-label profile__add-more-content">
              <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
              <span>Add More</span>
            </span>
            <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
          </solid-ui-button>
          <solid-ui-button
            type="button"
            variant="icon"
            size="sm"
            class="profile-section-collapsible__toggle-button"
            aria-label="Toggle languages section"
            aria-controls="languages-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
          </solid-ui-button>
        </div>
      </header>
      <div id="languages-panel" class="profile-section-collapsible__content">
        ${renderOwnerEmptyLanguagesContent(store, subject, languages, viewerMode, onSaved)}
      </div>
    </section>
  `;
}
function renderLanguageSection(store, subject, languages, viewerMode, onSaved) {
  const safeLanguages = languages || [];
  const hasLanguages = Array.isArray(safeLanguages) && safeLanguages.length > 0;
  const showOwnerEmptyLanguages = !hasLanguages && viewerMode === 'owner';
  const showSection = true;
  return showSection ? (0, _litHtml.html)`
    ${showOwnerEmptyLanguages ? renderOwnerEmptyLanguagesSection(store, subject, safeLanguages, viewerMode, onSaved) : renderLanguagesSectionDefault(store, subject, safeLanguages, viewerMode, onSaved)}
  ` : '';
}